<template>
	<svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" :viewBox="`0 0 ${width} ${height}`">

		<rect
			x="1" y="1"
			:width="width - 2" :height="height - 2"
			rx="5"
			:fill="fill"
			stroke="currentColor"
			stroke-width="1.5"
		/>

		<text
			:x="width / 2"
			:y="height / 2"
			fill="currentColor"
			font-family="Arial, sans-serif"
			font-size="12"
			font-weight="700"
			letter-spacing="1.5"
			text-anchor="middle"
			dominant-baseline="middle"
		>
			PREMIUM KANZLEI
		</text>

	</svg>
</template>

<script>
export default {
	name: 'PremiumBadge',
	props: {
		width:  { type: Number, default: 200 },
		height: { type: Number, default: 36 },
		fill:  { type: String, default: 'none' },
	},
}
</script>